

import 'gridstack/dist/gridstack.min.css';
import { GridItemHTMLElement, GridStack, GridStackElement } from 'gridstack';
import { NSpin } from 'naive-ui';
import 'gridstack/dist/h5/gridstack-dd-native';
import { defineComponent, PropType } from "vue";

import { delay } from '~/misc/time';
import { Widget, WidgetType } from '~/models/widget.model';
import { WidgetMode } from "~/components/widgets/widget.vue";
import registry from '~/components/widgets/widget-registry';
import componentBase from '~/components/component-base';

export default defineComponent({

    extends: componentBase,

    components: {
        NSpin,

        ...registry.getComponents(),
    },


    props: {
        mode: { type: String as PropType<WidgetMode>, default: WidgetMode.SHOW },
        widgets: { type: Array as PropType<Widget[]>, default: () => []}
    },

    data() {
        return {
            grid: null as GridStack | null,
            ready: false,
            WidgetType: WidgetType,
        }
    },

    mounted(): void {
        if(this.grid || !this.widgets) {
            return;
        }

        this.resetGrid();
    },

    computed: {

        cellHeight() {
            //@ts-ignore
            return Math.max(this.$refs?.grid?.offsetHeight / 3, 230);
        },

        editable() {
            return this.mode === WidgetMode.EDIT;
        }
    },

    methods: {
        async resetGrid(): Promise<void> {
            if(!this.$refs.grid || !this.widgets) {
                return;
            }

            if (this.grid) {
                this.ready = false;
                this.grid.off('change');
                this.grid.destroy(false);
                this.grid = null;
            }

            await delay(200);
            
            const grid = this.grid = GridStack.init({
                disableResize: !this.editable,
                disableDrag: !this.editable,
                cellHeight: this.cellHeight,
                column: 12,
                minRow: 3,
            }, this.$refs.grid as GridStackElement);

            this.ready = true;

            if (!this.editable) {
                return;
            }
            
            grid.on('change', async () => {
                let widgets = [];

                if(!grid) {
                    return;
                }

                widgets = grid.getGridItems()
                    .map((gihe: GridItemHTMLElement) => {
                        const node = gihe.gridstackNode;
                        if(!node) {
                            return null;
                        }

                        const type = gihe.getAttribute('gs-type');
                        return {
                            id: node.id,
                            x: node.x,
                            y: node.y,
                            height: node.h,
                            width: node.w,
                            minWidth: node.minW,
                            minHeight: node.minH,
                            type, 
                        } as Widget;
                    })
                    .filter(w => w);
                
                this.$emit('grid:change', widgets);
            });
        },
    },

    watch: {
        widgets(value: Widget[]) {

            if(!value) {
                return;
            }

            // if grid is in edit mode, grid init should initiated elsewhere
            if(this.editable) {
                return;
            }

            // Grid is already initiated
            if(this.grid || this.ready) {
                return;
            }

            this.resetGrid();

        }
    }
});
